import { TicketItemModifierAdapter as i } from "../ticketItemModifier/ticketItemModifier.adapter.js";
import { Adapter as r, getAdapter as m } from "../../../adapter.js";
import { TicketItemModel as s } from "./ticketItem.model.js";
class l extends r {
  adapt(e) {
    var t;
    const o = m(i);
    return new s(
      {
        itemId: e.item_id,
        refItemId: e.ref_item_id,
        skuCode: e.sku_code,
        name: e.name,
        voucherCode: e.voucher_code,
        quantity: e.quantity,
        subtotal: e.subtotal,
        taxes: e.taxes,
        total: e.total,
        notes: e.notes,
        modifiers: (t = e.modifiers) == null ? void 0 : t.map(o.adapt),
        totalItems: e.total_items,
        combo: e.combo,
        description: e.description
      }
    );
  }
  serialize(e) {
  }
}
export {
  l as TicketItemAdapter
};
//# sourceMappingURL=ticketItem.adapter.js.map
